import { useState, useEffect } from "react";
import { Staff } from "../types/staff";
import api from "../../../../../features/auth/axiosConfig";

export const useStaffData = (showDeletedStaffs: boolean) => {
  const [staffData, setStaffData] = useState<Staff[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStaffData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/app/v1/pos/staff?include_deleted=${showDeletedStaffs}`
      );
      setStaffData(response.data.result || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching staff data:", err);
      setError("Failed to fetch staff data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffData();
  }, [showDeletedStaffs]);

  return { staffData, loading, error, refetch: fetchStaffData };
};